import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHookSection() {
  return <section className="bg-white py-12 px-4" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl text-gray-700" data-id="element-114">
          <p className="mb-6 leading-relaxed" data-id="element-115">
            Faltan pocas semanas para que empiecen las clases y recibes el
            correo de la escuela:
          </p>

          <blockquote className="border-l-4 border-coral pl-6 py-2 my-5 bg-cream/50 rounded-r-xl italic text-dark-teal font-medium" data-id="element-116">
            "Su hijo debe ser independiente en el uso del baño para asistir".
          </blockquote>

          <p className="mb-6 leading-relaxed" data-id="element-117">
            El pánico se apodera de ti. Has intentado de todo: stickers,
            premios, llevarlo cada 10 minutos... pero nada funciona. El tiempo
            corre, los pañales en Target están cada día más caros y sientes que
            eres la única mamá en el grupo cuya criatura todavía depende de un
            "Pull-Up".
          </p>

          <p className="text-2xl font-heading font-bold text-dark-teal mt-6 text-center bg-light-teal/30 py-4 px-6 rounded-2xl" data-id="element-118">
            No es tu culpa, es el método lo que está fallando.
          </p>
        </motion.div>
      </div>
    </section>;
}